// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ApVdb","title":"Header_title__1yo9M","side":"Header_side__1pSEW"};